// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"80b4202f","204":"1f3ddb10","416":"34c13a97","791":"8a4c80af"}[chunkId] + ".chunk.js";
};